import { api } from "./api";

const ADMIN_KEY_STORAGE = "cbb-admin-key";

export async function getDrop() {
  const res = await api.get("/archive/drop");
  return res.data;
}

export async function getActivity(limit = 6) {
  const res = await api.get(`/archive/activity?limit=${limit}`);
  return res.data;
}

export async function submitGuess(character_id, nation) {
  const res = await api.post("/archive/guess", { character_id, nation });
  return res.data;
}

export async function redeemCode(code) {
  const res = await api.post("/archive/redeem", { code });
  return res.data;
}

export async function getUnlocked() {
  const res = await api.get("/archive/unlocked");
  return res.data.characters || [];
}

export async function getArchiveStats() {
  const res = await api.get("/archive/stats");
  return res.data;
}

// Admin helpers (key stored in localStorage)
export function setAdminKey(k) {
  localStorage.setItem(ADMIN_KEY_STORAGE, k);
}
export function getAdminKey() {
  return localStorage.getItem(ADMIN_KEY_STORAGE) || "";
}
export function clearAdminKey() {
  localStorage.removeItem(ADMIN_KEY_STORAGE);
}

function adminHeaders() {
  return { "X-Admin-Key": getAdminKey() };
}

export async function adminList() {
  const res = await api.get("/admin/archive/characters", { headers: adminHeaders() });
  return res.data.characters || [];
}
export async function adminCreate(payload) {
  const res = await api.post("/admin/archive/characters", payload, { headers: adminHeaders() });
  return res.data;
}
export async function adminUpdate(id, payload) {
  const res = await api.put(`/admin/archive/characters/${id}`, payload, { headers: adminHeaders() });
  return res.data;
}
export async function adminSiteStats() {
  const res = await api.get("/admin/archive/site-stats", { headers: adminHeaders() });
  return res.data;
}
export async function adminDelete(id) {
  const res = await api.delete(`/admin/archive/characters/${id}`, { headers: adminHeaders() });
  return res.data;
}
export async function adminResetWeek() {
  const res = await api.post("/admin/archive/reset-week", {}, { headers: adminHeaders() });
  return res.data;
}
export async function adminTriviaCompletions() {
  const res = await api.get("/admin/archive/trivia-completions", { headers: adminHeaders() });
  return res.data;
}
export async function adminSnapshotSuperfan() {
  const res = await api.post("/admin/archive/superfan-snapshot", {}, { headers: adminHeaders() });
  return res.data;
}
export async function adminGetSuperfanSnapshot() {
  const res = await api.get("/admin/archive/superfan-snapshot", { headers: adminHeaders() });
  return res.data;
}

// Client-side guessed-this-drop tracking (works for both weekly_key and con drop_id).
const GUESSED_PREFIX = "cbb-archive-guessed-";
export function hasGuessedThisWeek(drop_key) {
  if (!drop_key) return false;
  return localStorage.getItem(GUESSED_PREFIX + drop_key) === "1";
}
export function markGuessedThisWeek(drop_key) {
  if (!drop_key) return;
  localStorage.setItem(GUESSED_PREFIX + drop_key, "1");
}

// =====================================================================
// Personal Archive Tally — counts EVERY character this browser
// personally cracked (correct guess) or redeemed via code.
// Used for the Anime NYC contest verification (no logins required).
// =====================================================================
const PERSONAL_KEY = "cbb-personal-unlocks";

export function getPersonalUnlocks() {
  try {
    const raw = localStorage.getItem(PERSONAL_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return (parsed && typeof parsed === "object") ? parsed : {};
  } catch {
    return {};
  }
}

export function getPersonalCount() {
  return Object.keys(getPersonalUnlocks()).length;
}

export function recordPersonalUnlock(character) {
  if (!character || !character.id) return;
  try {
    const map = getPersonalUnlocks();
    if (!map[character.id]) {
      map[character.id] = {
        name: character.name || "",
        nation: character.nation || "",
        rarity: character.rarity || "C",
        at: new Date().toISOString(),
      };
      localStorage.setItem(PERSONAL_KEY, JSON.stringify(map));
    }
  } catch { /* no-op */ }
}

export const NATIONS_LIST = [
  { slug: "verdani",  name: "Verdani",  accent: "#4A7C3A", sigil: "/art/symbol_verdani.jpg" },
  { slug: "khepera",  name: "Khepera",  accent: "#C5A059", sigil: "/art/symbol_khepera.jpg" },
  { slug: "akira",    name: "Akirans",  accent: "#A8323A", sigil: "/art/symbol_akira.jpg" },
  { slug: "namtaria", name: "Namtaria", accent: "#B33A8C", sigil: "/art/symbol_namtaria.jpg" },
  { slug: "specula",  name: "Specula",  accent: "#9EA9B4", sigil: "/art/symbol_specula.jpg" },
  { slug: "theraka",  name: "Theraka",  accent: "#7C2C2C", sigil: "/art/symbol_theraka.jpg" },
  { slug: "abyssari", name: "Abyssari", accent: "#6F4FB5", sigil: "/art/symbol_abyssari.jpg" },
  { slug: "zar",      name: "Zar",      accent: "#3B6BA8", sigil: "/art/symbol_zar.jpg" },
  { slug: "arathia",  name: "Arathia",  accent: "#D4AF68", sigil: "/art/symbol_arathia.jpg" },
];

export const NATION_BY_SLUG = NATIONS_LIST.reduce((acc, n) => {
  acc[n.slug] = n;
  return acc;
}, {});

export const RARITY_STYLES = {
  C: { label: "C Rank", color: "#A39E99", bg: "rgba(163,158,153,0.12)" },
  B: { label: "B Rank", color: "#5BAE5B", bg: "rgba(91,174,91,0.12)" },
  A: { label: "A Rank", color: "#5B9DFF", bg: "rgba(91,157,255,0.14)" },
  S: { label: "S Rank", color: "#C5A059", bg: "rgba(197,160,89,0.18)" },
};
